export default __webpack_public_path__ + "static/media/show1.17b6c8bf.jpg";